import { ApiError, CenteredLoader } from "@shared/primitive-components"
import { useEffect } from "react"
import { useResolveEntries, ResolvedFleetEntry, AddedFleetEntry } from "../../../api/fleet"

interface GetServerResolvedVehiclesProps {
  entries: ReadonlyArray<AddedFleetEntry>
  onDone: (
    resolved: ReadonlyArray<ResolvedFleetEntry>,
    unresolved: ReadonlyArray<AddedFleetEntry>,
    vehicleSetId: string
  ) => void
}

export const FindResolvedEntries = ({ entries, onDone }: GetServerResolvedVehiclesProps) => {
  const [res] = useResolveEntries({ entries })

  useEffect(() => {
    if (res.result?.tag !== `ok`) return
    onDone(res.result.data.resolved, res.result.data.unresolved, res.result.data.vehicleSetId)
  }, [res.result, onDone])

  if (res.result?.tag === `err`) {
    return <ApiError error={res.result.error.type} />
  }

  if (res.loading || !res.result) return <CenteredLoader />

  return null
}
